// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__H2G7v","label":"styles_label__dSSD5"};